export const SET_PENDING = 'AUTH/SET_PENDING';
export const SET_TOKEN = 'AUTH/SET_TOKEN';
export const SET_ERROR = 'AUTH/SET_ERROR';
export const SIGN_OUT = 'AUTH/SIGN_OUT';
